import React, { ChangeEventHandler, type FC } from "react";
import ColumnText from "./ColumnText";
import { EditorMode } from "@/app/nutrition/editor-mode.enum";
import { Meal } from "@/app/nutrition/meal.enum";
import { InputWithUnit } from "./InputWithUnit";
import EllipsesMenuTableNutrition from "./EllipsesMenuTableNutrition";

export type NutritionMealTableSuplementationProps = {
  suplementation: any;
  onChange: ChangeEventHandler<HTMLInputElement>;
  editorMode?: EditorMode;
  meal: Meal;
  index: number;
};

export const NutritionMealTableSuplementation: FC<
  NutritionMealTableSuplementationProps
> = ({ suplementation, editorMode, onChange, meal, index }) => {
  return (
    <tr>
      <ColumnText title={suplementation?.product} />
      <td className={"whitespace-nowrap px-3 py-5 text-sm text-gray-500"}>
        {editorMode === EditorMode.TrainingDay && (
          <div className="w-[100px]">
            <InputWithUnit
              value={suplementation.portion}
              onChange={onChange}
              name={`suplementations.[${meal}].[${index}].portion`}
            />
          </div>
        )}
        {editorMode === EditorMode.RestDay && (
          <div className="w-[100px]">
            <InputWithUnit
              value={suplementation.portionRest}
              onChange={onChange}
              name={`suplementations.[${meal}].[${index}].portionRest`}
            />
          </div>
        )}
      </td>
      <td className="relative whitespace-nowrap py-5 pl-3 pr-4 text-sm font-medium sm:pr-0 flex justify-end mr-5">
        <EllipsesMenuTableNutrition onDelete={() => {}} />
      </td>
    </tr>
  );
};
